import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Pomona Park. All rights reserved.</p>
        <p>pomonaparkofficial@gmail.com</p>
      </div>
    </footer>
  );
}

export default Footer;
